<template>
  <div class="login-container">
    <div class="login-box">
      <!-- EMAIL_AUTH_TEMP_DISABLED_START 0.9.6.0.1: email confirmation prompt -->
      <!-- <div v-if="showConfirmEmailPrompt" class="confirm-email-prompt"> -->
      <!--   <h3>Check your email!</h3> -->
      <!--   <p>We've sent a confirmation link to <strong>{{ email }}</strong></p> -->
      <!--   <p class="confirm-email-hint text-sm mt-2"> -->
      <!--     Click the link in the email to confirm your account. -->
      <!--     Haven't received the email? -->
      <!--   </p> -->
      <!--   <button  -->
      <!--     @click="resendConfirmationEmail" -->
      <!--     class="resend-button" -->
      <!--     :disabled="resendLoading" -->
      <!--   > -->
      <!--     <span v-if="resendLoading" class="loading-spinner"></span> -->
      <!--     {{ resendLoading ? 'Sending...' : 'Resend confirmation email' }} -->
      <!--   </button> -->
      <!--   <button  -->
      <!--     @click="resetRegistration"  -->
      <!--     class="back-button" -->
      <!--   > -->
      <!--     Back to login -->
      <!--   </button> -->
      <!-- </div> -->
      <!-- EMAIL_AUTH_TEMP_DISABLED_END 0.9.6.0.1 -->
      <div class="login-header">
        <AppLogo class="login-brand-logo" @logo-click="trackLogoNavigation" />
        <!-- <h2 class="title">Welcome</h2> -->
      </div>

      <div v-if="userStore.loginError" class="error-message" role="alert">
        {{ t('login.authFailed') }}
        <button class="close-error" :aria-label="t('login.closeError')" @click="userStore.clearError">×</button>
      </div>

      <div class="social-login-stack" aria-label="Social sign in options" :aria-busy="userStore.loginLoading">
        <button
          type="button"
          @click="signInWithGoogle"
          class="social-button"
          :disabled="userStore.loginLoading"
        >
          <svg
            class="social-icon"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 48 48"
            width="24px"
            height="24px"
          >
            <path
              fill="#FFC107"
              d="M43.611,20.083H42V20H24v8h11.303c-1.649,4.657-6.08,8-11.303,8c-6.627,0-12-5.373-12-12c0-6.627,5.373-12,12-12c3.059,0,5.842,1.154,7.961,3.039l5.657-5.657C34.046,6.053,29.268,4,24,4C12.955,4,4,12.955,4,24c0,11.045,8.955,20,20,20c11.045,0,20-8.955,20-20C44,22.659,43.862,21.35,43.611,20.083z"
            />
            <path
              fill="#FF3D00"
              d="M6.306,14.691l6.571,4.819C14.655,15.108,18.961,12,24,12c3.059,0,5.842,1.154,7.961,3.039l5.657-5.657C34.046,6.053,29.268,4,24,4C16.318,4,9.656,8.337,6.306,14.691z"
            />
            <path
              fill="#4CAF50"
              d="M24,44c5.166,0,9.86-1.977,13.409-5.192l-6.19-5.238C29.211,35.091,26.715,36,24,36c-5.202,0-9.619-3.317-11.283-7.946l-6.522,5.025C9.505,39.556,16.227,44,24,44z"
            />
            <path
              fill="#1976D2"
              d="M43.611,20.083H42V20H24v8h11.303c-0.792,2.237-2.231,4.166-4.087,5.571c0.001-0.001,0.002-0.001,0.003-0.002l6.19,5.238C36.971,39.205,44,34,44,24C44,22.659,43.862,21.35,43.611,20.083z"
            />
          </svg>
          {{ t('login.signInWithGoogle') }}
        </button>

        <button
          type="button"
          @click="signInWithTwitter"
          class="social-button"
          :disabled="userStore.loginLoading"
        >
          <svg
            class="social-icon"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 48 48"
            width="24px"
            height="24px"
          >
            <path
              d="M 11 4 C 7.134 4 4 7.134 4 11 L 4 39 C 4 42.866 7.134 46 11 46 L 39 46 C 42.866 46 46 42.866 46 39 L 46 11 C 46 7.134 42.866 4 39 4 L 11 4 z M 13.085938 13 L 21.023438 13 L 26.660156 21.009766 L 33.5 13 L 36 13 L 27.789062 22.613281 L 37.914062 37 L 29.978516 37 L 23.4375 27.707031 L 15.5 37 L 13 37 L 22.308594 26.103516 L 13.085938 13 z M 16.914062 15 L 31.021484 35 L 34.085938 35 L 19.978516 15 L 16.914062 15 z"
            ></path>
          </svg>
          {{ t('login.signInWithTwitter') }}
        </button>

        <button
          type="button"
          @click="signInWithDiscord"
          class="social-button"
          :disabled="userStore.loginLoading"
        >
          <svg
            class="social-icon"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 48 48"
            width="24px"
            height="24px"
          >
            <path
              fill="#536dfe"
              d="M39.248,10.177c-2.804-1.287-5.812-2.235-8.956-2.778c-0.057-0.01-0.114,0.016-0.144,0.068	c-0.387,0.688-0.815,1.585-1.115,2.291c-3.382-0.506-6.747-0.506-10.059,0c-0.3-0.721-0.744-1.603-1.133-2.291	c-0.03-0.051-0.087-0.077-0.144-0.068c-3.143,0.541-6.15,1.489-8.956,2.778c-0.024,0.01-0.045,0.028-0.059,0.051	c-5.704,8.522-7.267,16.835-6.5,25.044c0.003,0.04,0.026,0.079,0.057,0.103c3.763,2.764,7.409,4.442,10.987,5.554	c0.057,0.017,0.118-0.003,0.154-0.051c0.846-1.156,1.601-2.374,2.248-3.656c0.038-0.075,0.002-0.164-0.076-0.194	c-1.197-0.454-2.336-1.007-3.432-1.636c-0.087-0.051-0.094-0.175-0.014-0.234c0.231-0.173,0.461-0.353,0.682-0.534	c0.04-0.033,0.095-0.04,0.142-0.019c7.201,3.288,14.997,3.288,22.113,0c0.047-0.023,0.102-0.016,0.144,0.017	c0.22,0.182,0.451,0.363,0.683,0.536c0.08,0.059,0.075,0.183-0.012,0.234c-1.096,0.641-2.236,1.182-3.434,1.634	c-0.078,0.03-0.113,0.12-0.075,0.196c0.661,1.28,1.415,2.498,2.246,3.654c0.035,0.049,0.097,0.07,0.154,0.052	c3.595-1.112,7.241-2.79,11.004-5.554c0.033-0.024,0.054-0.061,0.057-0.101c0.917-9.491-1.537-17.735-6.505-25.044	C39.293,10.205,39.272,10.187,39.248,10.177z M16.703,30.273c-2.168,0-3.954-1.99-3.954-4.435s1.752-4.435,3.954-4.435	c2.22,0,3.989,2.008,3.954,4.435C20.658,28.282,18.906,30.273,16.703,30.273z M31.324,30.273c-2.168,0-3.954-1.99-3.954-4.435	s1.752-4.435,3.954-4.435c2.22,0,3.989,2.008,3.954,4.435C35.278,28.282,33.544,30.273,31.324,30.273z"
            ></path>
          </svg>
          {{ t('login.signInWithDiscord') }}
        </button>
      </div>

      <p v-if="userStore.loginLoading" class="login-status" role="status" aria-live="polite">
        <span class="loading-spinner" aria-hidden="true"></span>
        {{ t('login.signingIn') }}
      </p>

      <!-- <button
          @click="signInWithFacebook"
          class="google-button"
          v-if="isSignIn"
          :disabled="userStore.loginLoading"
        >
          <svg class="facebook-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" width="24px" height="24px">
            <path fill="#1877F2" d="M24,4C12.954,4,4,12.954,4,24s8.954,20,20,20s20-8.954,20-20S35.046,4,24,4z"/>
            <path fill="var(--text-inverse)" d="M26.707,29.301h5.176l0.813-5.258h-5.989v-2.874c0-2.184,0.714-4.121,2.757-4.121h3.283V12.46 c-0.577-0.078-1.797-0.248-4.102-0.248c-4.814,0-7.636,2.542-7.636,8.334v3.498H16.06v5.258h4.948v14.452 C21.988,43.9,22.981,44,24,44c0.921,0,1.82-0.084,2.707-0.204V29.301z"/>
          </svg>
          Sign in with Facebook
        </button> -->

      <!-- EMAIL_AUTH_TEMP_DISABLED_START 0.9.6.0.1: email divider and form -->
      <!-- <div class="divider" v-if="isSignIn"> -->
      <!--   <span>Or continue with</span> -->
      <!-- </div> -->

      <!-- <form @submit.prevent="handleSubmit"> -->
      <!--   <div class="input-group"> -->
      <!--     <label for="email">Email</label> -->
      <!--     <input -->
      <!--       id="email" -->
      <!--       v-model="email" -->
      <!--       type="email" -->
      <!--       required -->
      <!--       placeholder="you@example.com" -->
      <!--       :disabled="userStore.loginLoading" -->
      <!--     /> -->
      <!--   </div> -->

      <!--   <div class="input-group"> -->
      <!--     <label for="password">Password</label> -->
      <!--     <div class="password-input"> -->
      <!--       <input -->
      <!--         id="password" -->
      <!--         v-model="password" -->
      <!--         :type="showPassword ? 'text' : 'password'" -->
      <!--         required -->
      <!--         placeholder="••••••••" -->
      <!--         :disabled="userStore.loginLoading" -->
      <!--       /> -->
      <!--       <button -->
      <!--         @click.prevent="togglePasswordVisibility" -->
      <!--         type="button" -->
      <!--         class="toggle-password" -->
      <!--         :disabled="userStore.loginLoading" -->
      <!--       > -->
      <!--         {{ showPassword ? 'Hide' : 'Show' }} -->
      <!--       </button> -->
      <!--     </div> -->
      <!--   </div> -->

      <!--   <div class="input-group" v-if="!isSignIn"> -->
      <!--     <label for="confirm-password">Confirm Password</label> -->
      <!--     <div class="password-input"> -->
      <!--       <input -->
      <!--         id="confirm-password" -->
      <!--         v-model="confirmPassword" -->
      <!--         :type="showPassword ? 'text' : 'password'" -->
      <!--         required -->
      <!--         placeholder="••••••••" -->
      <!--         :disabled="userStore.loginLoading" -->
      <!--       /> -->
      <!--     </div> -->
      <!--   </div> -->

      <!--   <button  -->
      <!--     type="submit"  -->
      <!--     class="submit-button" -->
      <!--     :disabled="userStore.loginLoading" -->
      <!--   > -->
      <!--     <span v-if="userStore.loginLoading" class="loading-spinner"></span> -->
      <!--     {{ isSignIn ? 'Sign In' : 'Sign Up' }} -->
      <!--   </button> -->
      <!-- </form> -->

      <!-- <div class="links"> -->
      <!--   <a  -->
      <!--     href="#"  -->
      <!--     class="forgot-password"  -->
      <!--     v-if="isSignIn" -->
      <!--     @click.prevent="handleForgotPassword" -->
      <!--   > -->
      <!--     Forgot password? -->
      <!--   </a> -->
      <!--   <p class="signup-link"> -->
      <!--     {{ isSignIn ? "Don't have an account?" : "Already have an account?" }} -->
      <!--     <a href="#" @click.prevent="toggleMode"> -->
      <!--       {{ isSignIn ? 'Sign up' : 'Sign in' }} -->
      <!--     </a> -->
      <!--   </p> -->
      <!-- </div> -->
      <!-- EMAIL_AUTH_TEMP_DISABLED_END 0.9.6.0.1 -->
    </div>
  </div>
</template>

<script setup>
import { onMounted } from "vue";
import { useI18n } from "vue-i18n";
import { useUserStore } from "@/core/store/useUserStore";
import { useRouter } from "vue-router";
import { supabase } from "../core/supabase";
import { useAuthAnalytics } from "@/core/analytics/hooks/useAuthAnalytics";
import { useNavigationAnalytics } from "@/core/analytics/hooks/useNavigationAnalytics";
import { useGoogleOneTap } from "@/composables/useGoogleOneTap";
import AppLogo from "@/components/AppLogo.vue";
import { resolveRedirectTarget } from "@/core/auth/authRedirect";

const router = useRouter();
const userStore = useUserStore();
const { t } = useI18n();
const authAnalytics = useAuthAnalytics();
const navigationAnalytics = useNavigationAnalytics();

// 登录页 Logo 点击：语义是「离开登录页回到首页」的导航入口，不是认证动作，
// 因此复用 Navigation 域的 app_navigation_clicked（source_position=login_header），
// 而不硬塞进 Auth 域的 auth_entry_clicked（后者专指登录/注册入口，会污染认证漏斗）。
const trackLogoNavigation = () => {
  navigationAnalytics.trackAppNavigationClicked({
    sourcePosition: "login_header",
    elementName: "logo",
    elementType: "link",
    // AppLogo 内部跳 /:lang/home，router 中 name='Landing'
    targetRouteName: "Landing",
    targetRouteType: "internal",
    method: "user_click",
    lang: router.currentRoute.value.params.lang,
    isLoggedIn: userStore.isLoggedIn
  });
};
// One Tap Google 登录逻辑已抽离为共享 composable（src/composables/useGoogleOneTap.js），
// 供 Login 与 Landing 复用。此处仅持有实例并保留手动 OAuth 与 One Tap 的互斥协调。
const googleOneTap = useGoogleOneTap({ sourcePosition: "login_page" });

// EMAIL_AUTH_TEMP_DISABLED_START 0.9.6.0.1: email form state
// const email = ref('')
// const password = ref('')
// const confirmPassword = ref('')
// const showPassword = ref(false)
// const isSignIn = ref(true)
// const showConfirmEmailPrompt = ref(false)
// const resendLoading = ref(false)
// EMAIL_AUTH_TEMP_DISABLED_END 0.9.6.0.1

onMounted(async () => {
  const sessionCheckStart = performance.now();
  // 捕获 OAuth 回调失败原因（D5：稳定 reasonCode，跨路由不依赖 store 错误保留）
  const callbackFailure =
    router.currentRoute.value.query.reasonCode === "oauth_callback_failed";
  // 初始 session-check 期间锁定按钮，避免 checkAuth 未完成前误触 OAuth / One Tap（方案 §13.1）
  userStore.loginLoading = true;
  await userStore.checkAuth();
  const sessionCheckDuration = Math.round(
    performance.now() - sessionCheckStart
  );

  const currentLang = router.currentRoute.value.params.lang;
  // 先取原始 query.redirect 用于判定「URL 是否真有 redirect 参数」，
  // 缺失时再用默认 /:lang/upload 兜底（仅用于导航与分类，不改变 redirectPresent 语义）。
  const queryRedirect = router.currentRoute.value.query.redirect;
  const redirect = queryRedirect || `/${currentLang}/upload`;
  const resolvedRedirect = resolveRedirectTarget(redirect, { lang: currentLang });
  const redirectTarget = resolvedRedirect.target;
  const redirectPresent = !!queryRedirect;

  if (userStore.isLoggedIn) {
    authAnalytics.trackAuthSessionCheckCompleted({
      actionStatus: "success",
      isLoggedIn: true,
      reasonCode: "already_logged_in",
      durationMs: sessionCheckDuration,
    });
    try {
      await router.push(resolvedRedirect.path);
      authAnalytics.trackAuthRedirectCompleted({
        actionStatus: "success",
        sourcePosition: "login_page",
        redirectTarget,
        redirectPresent,
        authFlow: "login",
        reasonCode: "already_logged_in",
      });
    } catch (error) {
      authAnalytics.trackAuthRedirectCompleted({
        actionStatus: "failed",
        sourcePosition: "login_page",
        redirectTarget,
        redirectPresent,
        authFlow: "login",
        reasonCode: "router_push_failed",
        errorCode: error?.code || error?.name,
      });
    }
  } else {
    // 根据稳定的 reasonCode 重生成通用错误提示（方案 §4.8/D5）：
    // AuthCallback 失败跳转时写入的 loginError 会被上方 checkAuth 的 resetState 清空，
    // 因此在此依据 reasonCode 重新生成，避免「错误一闪而过 / 完全看不到」。
    if (callbackFailure) {
      userStore.loginError = "Authentication failed. Please try again.";
      // 消费后清理 URL 上的 reasonCode，避免刷新 / 返回重复提示
      const currentQuery = { ...router.currentRoute.value.query };
      delete currentQuery.reasonCode;
      router.replace({ query: currentQuery }).catch(() => {});
    }
    userStore.loginLoading = false;
    authAnalytics.trackAuthPageViewed({
      authFlow: "login",
      sourcePosition: "login_page",
      redirectTarget,
      redirectPresent,
      isLoggedIn: false,
      lang: currentLang,
    });
    await googleOneTap.initializeGoogleOneTap();
  }
});

// EMAIL_AUTH_TEMP_DISABLED_START 0.9.6.0.1: email handler functions
// const toggleMode = () => {
//   const nextIsSignIn = !isSignIn.value;
//   isSignIn.value = nextIsSignIn;
//   userStore.clearError();
//   showConfirmEmailPrompt.value = false;

//   authAnalytics.trackAuthModeSwitched({
//     authFlow: nextIsSignIn ? 'login' : 'signup',
//     sourcePosition: 'login_page',
//     elementName: nextIsSignIn ? 'toggle_signin' : 'toggle_signup',
//     elementType: 'link'
//   });
// }

const signInWithOAuthProvider = async (provider) => {
  // 单飞守卫（方案 §4.6 / §13.1 / §13.2）：首次请求 pending 期间或初始 session-check 锁定期间
  // 忽略后续点击，避免重复调用 Supabase、覆盖 pending provider 或重复 started 埋点。
  // oauthInFlight 由共享 One Tap composable 持有（手动 OAuth 与 One Tap 互斥，方案 §13.2）。
  if (googleOneTap.getOauthInFlight() || userStore.loginLoading) return;

  // redirect 解析结果需在 try/catch/finally 间共享，提前用 let 声明（块级作用域）
  let redirectTarget;
  let redirectPresent;

  try {
    // 进入 OAuth 流程即锁定按钮，避免重复触发（§13.1）。整段前置逻辑（含 redirect 解析、
    // sessionStorage、started 埋点）均纳入本 try/finally：若 sessionStorage 不可用（隐私模式等）
    // 在 try 之前抛 SecurityError，finally 仍会复位 oauthInFlight / loginLoading，避免按钮永久 disabled。
    googleOneTap.setOauthInFlight(true);
    userStore.loginLoading = true;
    userStore.loginError = null;

    // 用户选择手动 provider 时取消可能已展示的 One Tap 浮层（方案 §13.2）
    googleOneTap.cancelOneTap();

    const currentLang = router.currentRoute.value.params.lang;
    // 先取原始 query.redirect 用于判定「URL 是否真有 redirect 参数」，
    // 缺失时再用默认 /:lang/upload 兜底（仅用于导航与分类，不改变 redirectPresent 语义）。
    const queryRedirect = router.currentRoute.value.query.redirect;
    const redirect = queryRedirect || `/${currentLang}/upload`;
    const resolvedRedirect = resolveRedirectTarget(redirect, { lang: currentLang });
    redirectTarget = resolvedRedirect.target;
    redirectPresent = !!queryRedirect;

    // best-effort：存储受限（隐私模式等）时静默跳过，不影响 OAuth 发起（AUTH-02）
    try {
      sessionStorage.setItem("oauth_pending_provider", provider);
    } catch (_e) {
      // 忽略：pending provider 仅用于埋点归因，失败可降级
    }

    authAnalytics.trackAuthOauthStarted({
      method: provider,
      authFlow: "oauth_login",
      elementName: `${provider}_oauth_button`,
      elementType: "button",
      redirectTarget,
      redirectPresent,
    });

    // 仅当 URL 真有 redirect 参数时才把它塞进 OAuth 回跳地址；
    // 缺失时不带 redirect 参数（AuthCallbackView 自身会兜底 /:lang/upload），
    // 避免把兜底路径误写成 redirect 导致回调阶段 redirect_present 误报（漏斗一致性）。
    const authCallbackBase = `${window.location.origin}/${currentLang}/auth-callback`;
    const redirectTo = queryRedirect
      ? `${authCallbackBase}?redirect=${encodeURIComponent(resolvedRedirect.path)}`
      : authCallbackBase;
    const options = { redirectTo };
    if (provider === "google") {
      options.queryParams = {
        prompt: "select_account",
        access_type: "offline",
      };
    }

    const oauthStart = performance.now();
    const { error } = await supabase.auth.signInWithOAuth({
      provider,
      options,
    });
    const oauthDuration = Math.round(performance.now() - oauthStart);

    if (error) throw error;

    authAnalytics.trackAuthOauthRedirectStarted({
      method: provider,
      actionStatus: "success",
      authFlow: "oauth_login",
      redirectTarget,
      redirectPresent,
      durationMs: oauthDuration,
    });
  } catch (error) {
    authAnalytics.trackAuthOauthRedirectStarted({
      method: provider,
      actionStatus: "failed",
      authFlow: "oauth_login",
      reasonCode: "oauth_redirect_failed",
      errorCode: error?.code || error?.name,
      redirectTarget,
      redirectPresent,
    });
    // 沿用既有通用错误文案，不向用户透传 SDK 原始错误（AUTH-04）；
    // 原始 error code 已在上方 trackAuthOauthRedirectStarted 的 errorCode 中保留埋点。
    userStore.loginError = "Authentication failed. Please try again.";
    // 失败留在页面：立即清理陈旧 pending provider（§4.7 首期策略）；best-effort 静默跳过（AUTH-02）
    try {
      sessionStorage.removeItem("oauth_pending_provider");
    } catch (_e) {
      // 忽略
    }
  } finally {
    googleOneTap.setOauthInFlight(false);
    userStore.loginLoading = false;
  }
};

const signInWithGoogle = () => signInWithOAuthProvider("google");
const signInWithTwitter = () => signInWithOAuthProvider("twitter");
const signInWithDiscord = () => signInWithOAuthProvider("discord");

// const mapAuthErrorToReasonCode = (error) => {
//   if (!error) return 'auth_request_failed';
//   if (typeof error === 'string') {
//     if (error.includes('Invalid login credentials')) return 'invalid_credentials';
//     if (error.includes('User not found')) return 'user_not_found';
//     if (error.includes('Email not confirmed')) return 'email_not_confirmed';
//     if (error.includes('Password too short')) return 'password_too_short';
//   }
//   return 'auth_request_failed';
// };

// const handleSubmit = async () => {
//   userStore.clearError();

//   const currentLang = router.currentRoute.value.params.lang;
//   const redirect = router.currentRoute.value.query.redirect || `/${currentLang}`;
//   const redirectTarget = normalizeRedirectTarget(redirect);
//   const redirectPresent = !!router.currentRoute.value.query.redirect;
//   const authFlow = isSignIn.value ? 'login' : 'signup';
//   const sourcePosition = isSignIn.value ? 'login_form' : 'signup_form';

//   if (!email.value || !password.value) {
//     authAnalytics.trackAuthSubmitCompleted({
//       authFlow,
//       method: 'email',
//       actionStatus: 'blocked',
//       reasonCode: 'missing_required_fields',
//       sourcePosition,
//       redirectTarget,
//       redirectPresent
//     });
//     userStore.loginError = 'Please fill in all fields';
//     return;
//   }

//   if (!isSignIn.value && password.value !== confirmPassword.value) {
//     authAnalytics.trackAuthSubmitCompleted({
//       authFlow,
//       method: 'email',
//       actionStatus: 'blocked',
//       reasonCode: 'password_mismatch',
//       sourcePosition,
//       redirectTarget,
//       redirectPresent
//     });
//     userStore.loginError = 'Passwords do not match';
//     return;
//   }

//   const submitStart = performance.now();
//   authAnalytics.trackAuthSubmitStarted({
//     authFlow,
//     method: 'email',
//     sourcePosition,
//     redirectTarget,
//     redirectPresent
//   });

//   try {
//     let result;
//     if (isSignIn.value) {
//       result = await userStore.login(email.value, password.value);
//     } else {
//       result = await userStore.register(email.value, password.value);
//     }

//     const submitDuration = Math.round(performance.now() - submitStart);

//     if (result.success) {
//       if (isSignIn.value) {
//         authAnalytics.trackAuthSubmitCompleted({
//           authFlow,
//           method: 'email',
//           actionStatus: 'success',
//           durationMs: submitDuration
//         });
//         let redirectSucceeded = false;
//         try {
//           await router.push(redirect);
//           redirectSucceeded = true;
//           authAnalytics.trackAuthRedirectCompleted({
//             actionStatus: 'success',
//             sourcePosition: 'login_page',
//             redirectTarget,
//             redirectPresent,
//             authFlow
//           });
//         } catch (error) {
//           authAnalytics.trackAuthRedirectCompleted({
//             actionStatus: 'failed',
//             sourcePosition: 'login_page',
//             redirectTarget,
//             redirectPresent,
//             authFlow,
//             reasonCode: 'router_push_failed',
//             errorCode: error?.code || error?.name
//           });
//         }
//         if (redirectSucceeded) {
//           await billingGuard.checkPostLogin();
//         }
//       } else {
//         authAnalytics.trackAuthSubmitCompleted({
//           authFlow,
//           method: 'email',
//           actionStatus: 'needs_email_confirmation',
//           reasonCode: 'email_confirmation_required',
//           durationMs: submitDuration
//         });
//         authAnalytics.trackAuthEmailConfirmationPromptViewed({
//           authFlow: 'signup',
//           method: 'email',
//           reasonCode: 'email_confirmation_required'
//         });
//         showConfirmEmailPrompt.value = true;
//       }
//     } else if (isSignIn.value && result.error?.includes && result.error.includes('Email not confirmed')) {
//       authAnalytics.trackAuthSubmitCompleted({
//         authFlow,
//         method: 'email',
//         actionStatus: 'needs_email_confirmation',
//         reasonCode: 'email_not_confirmed',
//         durationMs: submitDuration
//       });
//       authAnalytics.trackAuthEmailConfirmationPromptViewed({
//         authFlow: 'login',
//         method: 'email',
//         reasonCode: 'email_not_confirmed'
//       });
//       showConfirmEmailPrompt.value = true;
//     } else {
//       const reasonCode = mapAuthErrorToReasonCode(result.error);
//       authAnalytics.trackAuthSubmitCompleted({
//         authFlow,
//         method: 'email',
//         actionStatus: 'failed',
//         reasonCode,
//         durationMs: submitDuration
//       });
//       handleAuthError(result.error);
//     }
//   } catch (error) {
//     const submitDuration = Math.round(performance.now() - submitStart);
//     authAnalytics.trackAuthSubmitCompleted({
//       authFlow,
//       method: 'email',
//       actionStatus: 'failed',
//       reasonCode: 'auth_request_failed',
//       errorCode: error?.code || error?.name,
//       durationMs: submitDuration
//     });
//     console.error('Unexpected error:', error);
//     handleAuthError(error.message || error);
//   }
// }

// const handleAuthError = (error) => {
//   if (!error) return;

//   switch (error) {
//     case 'Invalid login credentials':
//       userStore.loginError = 'The email or password you entered is incorrect. Please try again.';
//       break;
//     case 'User not found':
//       userStore.loginError = 'No account found with this email. Please check your email or sign up.';
//       break;
//     case 'Email not confirmed':
//       userStore.loginError = 'Your email is not confirmed. Please check your inbox for a confirmation email.';
//       break;
//     case 'Password too short':
//       userStore.loginError = 'Password must be at least 6 characters long.';
//       break;
//     default:
//       userStore.loginError = 'The email or password you entered is incorrect. Please try again.';
//   }
// }

// const resendConfirmationEmail = async () => {
//   if (!email.value) {
//     authAnalytics.trackAuthConfirmationEmailResendCompleted({
//       actionStatus: 'blocked',
//       reasonCode: 'email_missing',
//       sourcePosition: 'confirm_email_prompt'
//     });
//     return;
//   }

//   authAnalytics.trackAuthConfirmationEmailResendStarted({
//     sourcePosition: 'confirm_email_prompt',
//     authFlow: isSignIn.value ? 'login' : 'signup',
//     method: 'email'
//   });

//   resendLoading.value = true;
//   try {
//     const resendStart = performance.now();
//     const { error } = await supabase.auth.resend({
//       type: 'signup',
//       email: email.value,
//       options: {
//         emailRedirectTo: `${window.location.origin}/#/`
//       }
//     });
//     const resendDuration = Math.round(performance.now() - resendStart);

//     if (error) throw error;

//     authAnalytics.trackAuthConfirmationEmailResendCompleted({
//       actionStatus: 'success',
//       sourcePosition: 'confirm_email_prompt',
//       authFlow: isSignIn.value ? 'login' : 'signup',
//       method: 'email',
//       durationMs: resendDuration
//     });
//     alert('Confirmation email has been sent!');
//   } catch (error) {
//     authAnalytics.trackAuthConfirmationEmailResendCompleted({
//       actionStatus: 'failed',
//       reasonCode: 'resend_confirmation_failed',
//       errorCode: error?.code || error?.name,
//       sourcePosition: 'confirm_email_prompt',
//       authFlow: isSignIn.value ? 'login' : 'signup',
//       method: 'email'
//     });
//     userStore.loginError = error.message;
//   } finally {
//     resendLoading.value = false;
//   }
// }

// const resetRegistration = () => {
//   authAnalytics.trackAuthModeSwitched({
//     authFlow: 'login',
//     sourcePosition: 'confirm_email_prompt',
//     reasonCode: 'back_to_login'
//   });
//   showConfirmEmailPrompt.value = false;
//   isSignIn.value = true;
//   email.value = '';
//   password.value = '';
//   confirmPassword.value = '';
//   userStore.clearError();
// }

//   const handleForgotPassword = async () => {
//     if (!email.value) {
//       userStore.loginError = 'Please enter your email address'
//       return
//     }

//     try {
//       const { error } = await supabase.auth.resetPasswordForEmail(email.value, {
//         redirectTo: `${window.location.origin}/#/reset-password`,
//       })
//       if (error) throw error
//       alert('Password reset instructions have been sent to your email')
//     } catch (error) {
//       userStore.loginError = error.message
//     }
//   }

// const togglePasswordVisibility = () => {
//   showPassword.value = !showPassword.value
// }
// EMAIL_AUTH_TEMP_DISABLED_END 0.9.6.0.1
</script>

<style scoped>
.login-container {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  padding: clamp(2rem, 6vw, 5rem) 1rem;
  overflow: hidden;
  background-color: var(--app-page-bg);
}

.login-container::before,
.login-container::after {
  content: "";
  position: absolute;
  z-index: 0;
  border-radius: 9999px;
  pointer-events: none;
}

.login-container::before {
  width: min(28rem, 68vw);
  height: min(28rem, 68vw);
  top: 6%;
  right: 50%;
  background: radial-gradient(
    circle,
    color-mix(in srgb, var(--theme-gradient-start) 18%, transparent) 0%,
    transparent 68%
  );
  transform: translateX(-4rem);
}

.login-container::after {
  width: min(24rem, 62vw);
  height: min(24rem, 62vw);
  bottom: 4%;
  left: 52%;
  background: radial-gradient(
    circle,
    color-mix(in srgb, var(--theme-gradient-end) 16%, transparent) 0%,
    transparent 66%
  );
  transform: translateX(3rem);
}

.login-box {
  position: relative;
  z-index: 1;
  background: radial-gradient(
      circle at top left,
      color-mix(in srgb, var(--theme-primary-soft-bg) 44%, transparent) 0%,
      transparent 36%
    ),
    linear-gradient(
      145deg,
      color-mix(in srgb, var(--surface-card) 96%, var(--surface-card-hover)) 0%,
      var(--surface-card) 100%
    );
  border: 1px solid
    color-mix(in srgb, var(--theme-gradient-start) 16%, var(--border-default));
  border-radius: 24px;
  box-shadow: 0 24px 64px
      color-mix(in srgb, var(--shadow-color) 76%, transparent),
    inset 0 1px 0 color-mix(in srgb, var(--text-inverse) 30%, transparent);
  padding: clamp(1.5rem, 4vw, 2.25rem);
  width: 100%;
  max-width: 430px;
  transition: box-shadow 0.25s ease, transform 0.25s ease,
    border-color 0.25s ease;
}

.login-box:hover {
  border-color: color-mix(
    in srgb,
    var(--theme-gradient-start) 26%,
    var(--border-default)
  );
  box-shadow: 0 28px 72px
      color-mix(in srgb, var(--shadow-color) 82%, transparent),
    inset 0 1px 0 color-mix(in srgb, var(--text-inverse) 34%, transparent);
}

.login-header {
  display: grid;
  justify-items: center;
  gap: 0.55rem;
  margin-bottom: 1.75rem;
  text-align: center;
}

.login-brand-logo {
  justify-content: center;
  filter: drop-shadow(
    0 14px 18px color-mix(in srgb, var(--theme-primary) 24%, transparent)
  );
}

.title {
  font-size: clamp(1.75rem, 4vw, 2.15rem);
  font-weight: 800;
  line-height: 1.1;
  margin: 0;
  color: var(--text-primary);
  letter-spacing: -0.035em;
}

.subtitle {
  max-width: 18rem;
  margin: 0;
  color: var(--text-muted);
  font-size: 0.95rem;
  line-height: 1.55;
}

.social-login-stack {
  display: grid;
  gap: 0.75rem;
}

.social-button {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 0.85rem;
  width: 100%;
  min-height: 3.25rem;
  padding: 0.75rem 1rem;
  background: color-mix(
    in srgb,
    var(--surface-card) 88%,
    var(--surface-card-hover)
  );
  border: 1px solid color-mix(in srgb, var(--border-default) 82%, transparent);
  border-radius: 14px;
  color: var(--text-primary);
  cursor: pointer;
  transition: transform 0.2s ease, background-color 0.2s ease,
    border-color 0.2s ease, box-shadow 0.2s ease;
  font-size: 0.98rem;
  font-weight: 700;
  box-shadow: 0 6px 16px
    color-mix(in srgb, var(--shadow-color) 18%, transparent);
}

.social-button:hover {
  transform: translateY(-1px);
  background: color-mix(
    in srgb,
    var(--theme-primary-soft-bg) 22%,
    var(--surface-card)
  );
  border-color: color-mix(
    in srgb,
    var(--theme-gradient-start) 34%,
    var(--border-default)
  );
  box-shadow: 0 12px 24px
    color-mix(in srgb, var(--shadow-color) 28%, transparent);
}

.social-button:focus-visible {
  outline: none;
  border-color: color-mix(
    in srgb,
    var(--theme-primary) 56%,
    var(--border-default)
  );
  box-shadow: 0 0 0 3px var(--theme-focus-ring),
    0 12px 24px color-mix(in srgb, var(--shadow-color) 28%, transparent);
}

.social-icon {
  flex: 0 0 auto;
  width: 1.5rem;
  height: 1.5rem;
}

.social-button::after {
  content: "→";
  margin-left: auto;
  color: color-mix(in srgb, var(--theme-primary) 72%, var(--text-muted));
  font-size: 1rem;
  opacity: 0;
  transform: translateX(-0.25rem);
  transition: opacity 0.2s ease, transform 0.2s ease;
}

.social-button:hover::after,
.social-button:focus-visible::after {
  opacity: 1;
  transform: translateX(0);
}

.divider {
  display: flex;
  align-items: center;
  text-align: center;
  margin: 1.5rem 0;
}

.divider::before,
.divider::after {
  content: "";
  flex: 1;
  border-bottom: 1px solid var(--border-default);
}

.divider span {
  padding: 0 0.5rem;
  color: var(--text-muted);
  font-size: 0.875rem;
}

.input-group {
  margin-bottom: 1rem;
}

label {
  display: block;
  margin-bottom: 0.25rem;
  font-size: 0.875rem;
  color: var(--text-secondary);
}

input {
  width: 100%;
  padding: 0.5rem;
  border: 1px solid var(--input-border);
  background-color: var(--input-bg);
  color: var(--text-primary);
  border-radius: 4px;
  font-size: 1rem;
}

input::placeholder {
  color: var(--text-muted);
}

.password-input {
  position: relative;
}

.toggle-password {
  position: absolute;
  right: 0.5rem;
  top: 50%;
  transform: translateY(-50%);
  background: none;
  border: none;
  color: var(--text-muted);
  cursor: pointer;
}

.submit-button {
  width: 100%;
  padding: 0.5rem;
  border: none;
  border-radius: 4px;
  font-size: 1rem;
  color: var(--text-inverse);
  background-color: var(--theme-primary);
  cursor: pointer;
  transition: background-color 0.3s;
}

.submit-button:hover {
  background-color: var(--theme-primary-hover);
}

.links {
  margin-top: 1.5rem;
  text-align: center;
}

.forgot-password,
.signup-link a {
  color: var(--theme-gradient-start);
  text-decoration: none;
}

.forgot-password:hover,
.signup-link a:hover {
  text-decoration: underline;
}

.signup-link {
  margin-top: 0.5rem;
  font-size: 0.875rem;
  color: var(--text-secondary);
}

.error-message {
  background-color: color-mix(in srgb, #dc2626 12%, var(--surface-card));
  border: 1px solid color-mix(in srgb, #dc2626 48%, var(--border-default));
  color: color-mix(in srgb, #dc2626 85%, var(--text-primary));
  padding: 0.75rem 2.5rem 0.75rem 0.9rem;
  margin-bottom: 1rem;
  border-radius: 12px;
  position: relative;
  font-size: 0.875rem;
  line-height: 1.45;
}

.close-error {
  position: absolute;
  right: 0.5rem;
  top: 50%;
  transform: translateY(-50%);
  background: none;
  border: none;
  color: inherit;
  cursor: pointer;
  font-size: 1.25rem;
  padding: 0 0.25rem;
}

.loading-spinner {
  display: inline-block;
  width: 1rem;
  height: 1rem;
  border: 2px solid var(--text-inverse);
  border-radius: 50%;
  border-top-color: transparent;
  animation: spin 1s linear infinite;
  margin-right: 0.5rem;
}

.login-status {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 1rem;
  font-size: 0.9rem;
  color: var(--text-muted, #6b7280);
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

button:disabled {
  opacity: 0.62;
  cursor: not-allowed;
  transform: none;
  box-shadow: none;
}

@media (max-width: 480px) {
  .login-container {
    align-items: flex-start;
    min-height: 100vh;
    padding: 1.25rem 0.9rem 2.5rem;
  }

  .login-box {
    border-radius: 20px;
  }

  .social-button {
    min-height: 3rem;
    padding-inline: 0.9rem;
  }
}

input:disabled {
  background-color: var(--surface-card-hover);
  color: var(--text-muted);
  cursor: not-allowed;
}

.confirm-email-prompt {
  text-align: center;
  padding: 2rem 1rem;
}

.confirm-email-prompt h3 {
  font-size: 1.5rem;
  font-weight: bold;
  margin-bottom: 1rem;
  color: var(--text-primary);
}

.confirm-email-prompt p {
  margin-bottom: 1rem;
  color: var(--text-secondary);
}

.confirm-email-hint {
  color: var(--text-muted);
}

.confirm-email-prompt strong {
  color: var(--theme-primary);
}

.resend-button {
  width: 100%;
  padding: 0.5rem;
  background-color: var(--theme-gradient-start);
  color: white;
  border: none;
  border-radius: 4px;
  font-size: 1rem;
  margin-top: 1rem;
  cursor: pointer;
  transition: background-color 0.3s;
  display: flex;
  align-items: center;
  justify-content: center;
}

.resend-button:hover {
  background-color: var(--theme-primary);
}

.back-button {
  width: 100%;
  padding: 0.5rem;
  background-color: transparent;
  color: var(--text-secondary);
  border: 1px solid var(--border-default);
  border-radius: 4px;
  font-size: 1rem;
  margin-top: 1rem;
  cursor: pointer;
  transition: all 0.3s;
}

.back-button:hover {
  background-color: var(--surface-card-hover);
  color: var(--text-primary);
}
</style>
